<template>
    <div class="alibaba-report">
        <div class="main-button-bar">
            <el-select
                multiple
                collapse-tags
                v-model="params.statusArr"
                clearable
                placeholder="订单状态"
                class="search-item"
            >
                <el-option v-for="item in status" :key="item" :label="item" :value="item"></el-option>
            </el-select>

            <el-date-picker
                type="month"
                placeholder="统计时间（开始）"
                v-model="params.createDateStart"
                class="search-item"
                value-format="yyyy-MM-dd"
            ></el-date-picker>

            <el-date-picker
                type="month"
                placeholder="统计时间（截止）"
                v-model="params.createDateEnd"
                class="search-item"
                value-format="yyyy-MM-dd"
            ></el-date-picker>

            <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
        </div>

        <div :style="'height:' + (this.$tools.mainHeight() - 61) + 'px;overflow:auto;'">
            <el-card class="report-item box-card" v-for="(item, i) in records" :key="i">
                <div slot="header" class="clearfix">
                    <span>{{item.sellerName}} {{item.date}} 业绩</span>
                    <alibaba-received-info
                        :seller="item.seller"
                        :sellerName="item.sellerName"
                        :date="item.date"
                        :isRoot="false"
                        :status="getStatus()"
                    ></alibaba-received-info>
                </div>
                <div>
                    <div>成交订单量：{{item.number}}</div>
                    <div>成交销售额：{{$tools.parsecost(item.cost, true)}} $</div>
                    <div>当月实收额：{{$tools.parsecost(item.received, true)}} $</div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";
import AlibabaReceivedInfo from "./Alibaba-received-info.vue";
export default {
    components: { SnUserSearchInput, AlibabaReceivedInfo },
    data() {
        return {
            params: {statusArr: ["订单完成", "待买家支付尾款", "待买家确认已修改的合同", "待卖家确认尾款金额", "待卖家发货", "待买家确认收货", "发货中",]},
            status: [
                "订单关闭",
                "订单完成",
                "待买家付款",
                "待卖家接单",
                "待卖家确认订单",
                "待买家支付预付款",
                "待买家支付尾款",
                "待买家确认已修改的合同",
                "待卖家确认尾款金额",
                "待卖家发货",
                "待买家确认收货",
                "发货中",
            ],
            records: [],
        };
    },
    methods: {
        page(current) {
            let _this = this;

            _this.params.status = _this.params.statusArr.join(",");

            _this.$http.post(
                ["alibaba/order/myreport", _this.params],
                [
                    function (data) {
                        _this.records = data;
                    },
                ],
                ".alibaba-report"
            );
        },
        getStatus() {
            return this.params.statusArr.join(",");
        }
    },
};
</script>

<style lang="scss" scoped>
.report-item {
    width: 300px;
    margin: 15px;
    float: left;
}
</style>